import { combineReducers } from "redux";
import constants from "./constants";
import createApiReducer from "reducers/createReducers";

const reducers = combineReducers({
  setFacebookSettingsResult: createApiReducer(constants.SET_FACEBOOK_SETTINGS, {}),
  setFacebookeConversionStatusResult: createApiReducer(constants.SET_FACEBOOK_CONVERSION_STATUS, {}),
  setFacebookeConversionSettingStatusResult: createApiReducer(constants.SET_FACEBOOK_CONVERSION_SETTING_STATUS, {}),
  getFacebookSettingsResult: createApiReducer(constants.GET_FACEBOOK_SETTINGS, {}),
  getFacebookDaSettingsResult: createApiReducer(constants.GET_FACEBOOK_DA_SETTINGS, {}),
  getFacebookApiTokenResult: createApiReducer(constants.GET_FACEBOOK_API_TOKEN, {}),
  getFacebookBusinessListResult: createApiReducer(constants.GET_FACEBOOK_BUSINESS_LIST, {}),
  getFacebookAdsAccountListResult: createApiReducer(constants.GET_FACEBOOK_ADS_ACCOUNT_LIST, {}),
  getFacebookPixelCodeListResult: createApiReducer(constants.GET_FACEBOOK_PIXEL_CODE_LIST, {}),
  getFacebookPixelAgenciesResult: createApiReducer(constants.GET_FACEBOOK_PIXEL_AGENCIES, {}),
  getFacebookConversionLastSentResult: createApiReducer(constants.GET_FACEBOOK_CONVERSION_LAST_SENT, {}),
  getFacebookCRMConversionLastSentResult: createApiReducer(constants.GET_FACEBOOK_CRM_CONVERSION_LAST_SENT, {}),
  getFacebookConversionSettingByPipelineResult: createApiReducer(
    constants.GET_FACEBOOK_CONVERSION_SETTING_BY_PIPELINE,
    {},
  ),
  getFacebookAdsAccountAgenciesResult: createApiReducer(constants.GET_FACEBOOK_ADS_ACCOUNT_AGENCIES, {}),
  inviteFacebookAdsAccountResult: createApiReducer(constants.INVITE_FACEBOOK_ADS_ACCOUNT, {}),
  inviteFacebookPixelsResult: createApiReducer(constants.INVITE_FACEBOOK_PIXELS, {}),
  syncFacebookSettingWithRdynamicResult: createApiReducer(constants.SYNC_FACEBOOK_SETTING_WITH_RDYNAMIC, {}),
  syncFacebookSettingWithRmpResult: createApiReducer(constants.SYNC_FACEBOOK_SETTING_WITH_RMP, {}),
  changeSettingPageResult: createApiReducer(constants.CHANGE_FACEBOOK_SETTING_PAGE, { page: "signin" }),

  rwidgetConversionDefaultValueResult: createApiReducer(constants.RWIDGET_CONVERSION_DEFAULT_VALUE, {}),
  getRwidgetConversionDefaultValueResult: createApiReducer(constants.GET_RWIDGET_CONVERSION_DEFAULT_VALUE, {}),
  getFacebookPageIdResult: createApiReducer(constants.GET_FACEBOOK_PAGE_ID, {}),
  getFacebookFormListResult: createApiReducer(constants.GET_FACEBOOK_FORM_LIST, {}),
  getAllLeadFormSettingsResult: createApiReducer(constants.GET_ALL_LEAD_FORM_SETTINGS, {}),
  setFacebookAccountResult: createApiReducer(constants.SET_FACEBOOK_ACCOUNT, {}),
  getFacebookAccountResult: createApiReducer(constants.GET_FACEBOOK_ACCOUNT, {}),
  switchLeadFormStatusResult: createApiReducer(constants.SWITCH_LEAD_FORM_STATUS, {}),
  getLeadFormSettingResult: createApiReducer(constants.GET_LEAD_FORM_SETTING, {}),
  getFacebookPageSettingResult: createApiReducer(constants.GET_FACEBOOK_PAGE_SETTING, {}),
  getGoogleSettingResult: createApiReducer(constants.GET_GOOGLE_SETTING, {}),
  getCRMSettingResult: createApiReducer(constants.GET_CRM_SETTING, {}),
  setLeadFormSettingResult: createApiReducer(constants.SET_LEAD_FORM_SETTING, {}),
  getPageSettingResult: createApiReducer(constants.GET_PAGE_SETTING, {}),
  getFacebookUserInfoResult: createApiReducer(constants.GET_FACEBOOK_USER_INFO, {}),
  getFacebookNewAccessTokenResult: createApiReducer(constants.GET_FACEBOOK_NEW_ACCESS_TOKEN, {}),
  getFacebookPageAccessTokenResult: createApiReducer(constants.GET_FACEBOOK_PAGE_ACCESS_TOKEN, {}),
  getFacebookPageByUserIdResult: createApiReducer(constants.GET_FACEBOOK_PAGE_BY_USER_ID, {}),
  changePageUrlInputResult: createApiReducer(constants.CHANGE_PAGE_URL_INPUT, { pageUrl: "" }),
  changePageFormSelectTypeResult: createApiReducer(constants.CHANGE_PAGE_FORM_SELECT_TYPE, { pageFormSelectType: "" }),
  setCheckedFormItemsResult: createApiReducer(constants.SET_CHECKED_FORM_ITEMS, { checkedFormItems: [] }),
  archiveLeadFormSettingResult: createApiReducer(constants.ARCHIVE_LEAD_FORM_SETTING, {}),
  setFbConnectedResult: createApiReducer(constants.SET_FB_CONNECTED, { fbConnected: false }),
  setFbDisconnectedResult: createApiReducer(constants.SET_FB_DISCONNECTED, { fbDisconnected: false }),
  setGoogleConnectedResult: createApiReducer(constants.SET_GOOGLE_CONNECTED, { googleConnected: false }),
  setGoogleDisconnectedResult: createApiReducer(constants.SET_GOOGLE_DISCONNECTED, { googleDisconnected: false }),
  changeSheetsUrlInputResult: createApiReducer(constants.CHANGE_SHEETS_URL_INPUT, { sheetsUrl: "" }),
  getFacebookPageListResult: createApiReducer(constants.GET_FACEBOOK_PAGE_LIST, {}),
  getUserAccessTokenResult: createApiReducer(constants.GET_USER_ACCESS_TOKEN, {}),
  getFacebookPageListMoreResult: createApiReducer(constants.GET_FACEBOOK_PAGE_LIST_MORE, {}),
  setValidateFacebookLeadFormResult: createApiReducer(constants.SET_VALIDATE_FACEBOOK_LEAD_FORM, { validateForm: {} }),
  setDuplicateFacebookFormResult: createApiReducer(constants.SET_DUPLICATE_FACEBOOK_FORM, { duplicateForm: {} }),
  getGoogleSheetsCRMConversionsLastSendResult: createApiReducer(
    constants.GET_GOOGLE_SHEETS_CRM_CONVERSIONS_LAST_SEND,
    {},
  ),
  getDetailsPixelIdResult: createApiReducer(constants.GET_DETAILS_PIXEL_ID, {}),
  updateSheetsModifiedDataResult: createApiReducer(constants.UPDATE_SHEETS_MODIFIED_DATA, { updatedData: {} }),
  updateFbLeadFormSettingErrorStatusResult: createApiReducer(constants.UPDATE_FB_LEAD_FORM_SETTING_ERROR_STATUS, {}),
  setFileInfoErrorResult: createApiReducer(constants.SET_FILE_INFO_ERROR, { fileInfoError: "" }),
  setFacebookLoadingResult: createApiReducer(constants.SET_FACEBOOK_LOADING, { loading: false }),
  setFacebookFormLoadingResult: createApiReducer(constants.SET_FACEBOOK_FORM_LOADING, { loading: false }),
  setFacebookErrorResult: createApiReducer(constants.SET_FACEBOOK_ERROR, { error: false }),
  setFBConnectionLoadingResult: createApiReducer(constants.SET_FB_CONNECTION_LOADING, { loading: false }),
  setCRMConversionsLoadingResult: createApiReducer(constants.SET_CRM_CONVERSIONS_LOADING, { loading: false }),
});

export default reducers;
